/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Baixar o Bumble",
      "Aceitar todos",
      "Gerenciar opções",
      "Política de Cookies",
      "Voltar",
      "Número de telefone incorreto",
      "© {{current_year}} Bumble | Todos os direitos reservados",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Sobre",
      "Embaixadores",
      "O Buzz",
      "Este site utiliza cookies. Se você não alterar suas configurações, nós entendemos que você concorda com o uso de cookies.",
      "Baixar o app",
      "Baixar para Android",
      "Baixar para iOS",
      "Página não encontrada.",
      "Entrar",
      "Registrar",
      "Junte-se a nós!",
      "Ops, algo deu errado!"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dias"
            ],
            "singular": [
                  "dia"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mês"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "anos"
            ],
            "singular": [
                  "ano"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
